import React, { PureComponent, useEffect } from "react";
import {
  HashRouter as Router,
  Switch,
  Route,
  Link,
  withRouter,
} from "react-router-dom";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { setCssVar } from "@base/css";
import routes from "./App.routing";
import { triggerScroll } from "@base/scroll";
import Service from "@base/service";
import slugify from "slugify";
import { SliderWrapper } from "react-slider-wrapper";
import { fixUrl } from "./fixUrl";

import "./App.less";

slugify.extend({ ":": "-" });
const OnPageChange = withRouter(({ match }) => {
  // Classe CSS na tag HTML
  const prefixo = "page-";
  Array.from(document.documentElement.classList)
    .filter((className) => className.startsWith(prefixo))
    .forEach((className) =>
      document.documentElement.classList.remove(className)
    );
  let slug = slugify(match.path);
  if (slug === "") slug = "home";
  document.documentElement.classList.add(prefixo + slug);

  // Scroll animado
  useEffect(triggerScroll, []);

  return null;
});

class App extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      radio: null,
    };
    this.service = new Service();
    this.renderPage = this.renderPage.bind(this);
    this.renderHeader = this.renderHeader.bind(this);
    this.renderBanners = this.renderBanners.bind(this);
  }

  render() {
    if (this.state.loading) {
      return (
        <div className="App">
          <div className="loading">
            {this.state.radio ? (
              <img src={this.state.radio.logo} alt="" className="heartbeat" />
            ) : (
              "Carregando..."
            )}
          </div>
        </div>
      );
    } else {
      return (
        <div className="App">
          <HelmetProvider>
            <Router>
              <Switch>{routes.map(this.renderPage)}</Switch>
            </Router>
          </HelmetProvider>
        </div>
      );
    }
  }

  renderPage(route) {
    return (
      <Route key={route.path} path={route.path} exact={route.exact}>
        <OnPageChange />
        <Helmet>
          <title>{`${this.state.radio.name} | ${route.title}`}</title>
        </Helmet>
        {this.renderHeader()}
        {route.component()}
        {this.renderBanners()}
        {/* {this.renderFooter()} */}
      </Route>
    );
  }

  renderHeader() {
    return (
      <header>
        <Link to="/">
          <img
            src={fixUrl(this.state.radio.logo)}
            alt={this.state.radio.name}
            title={this.state.radio.name}
          />
        </Link>
      </header>
    );
  }

  renderBanners() {
    if (!this.state.radio.banners || this.state.radio.banners.length === 0) {
      setCssVar("--banner-height", "0px");
      return null;
    }
    // const images = [
    //   {"url_image_banner": "https://dummyimage.com/800x200/f00/fff.gif&text=lorem+ipsum"},
    //   {"url_image_banner": "https://dummyimage.com/800x200/f00/fff.gif&text=dolor+sit+amet", "href_banner": "https://google.com/"}
    // ];
    return (
      <>
        <div className="banners-ghost" />
        <div className="banners">
          <SliderWrapper
            settings={{
              dots: false,
              infinite: true,
              autoplaySpeed: 4000,
              autoplay: true,
              fade: true,
            }}
          >
            {this.state.radio.banners.map((banner) => {
              const img = (
                <img
                  src={fixUrl(banner.url_image_banner)}
                  alt=""
                  key={banner.url_image_banner}
                />
              );
              return banner.href_banner ? (
                <a
                  href={banner.href_banner}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {img}
                </a>
              ) : (
                img
              );
            })}
          </SliderWrapper>
        </div>
      </>
    );
  }

  renderFooter() {
    return (
      <footer>
        <iframe
          title="fb:like Facebook Social Plugin"
          frameBorder="0"
          allowtransparency=""
          scrolling="no"
          allow="encrypted-media"
          src="https://www.facebook.com/v2.10/plugins/like.php?action=like&amp;app_id=407743665993623&amp;channel=https%3A%2F%2Fstaticxx.facebook.com%2Fx%2Fconnect%2Fxd_arbiter%2F%3Fversion%3D46%23cb%3Dfb3810f925838%26domain%3Denergia97fm.fabriccaradio.com.br%26origin%3Dhttps%253A%252F%252Fenergia97fm.fabriccaradio.com.br%252Ff2063fcbd64505%26relation%3Dparent.parent&amp;container_width=600&amp;href=https%3A%2F%2Fwww.facebook.com%2Fenergia97fm&amp;layout=standard&amp;locale=pt_BR&amp;sdk=joey&amp;share=true&amp;show_faces=true&amp;size=large"
          allowFullScreen
        />
      </footer>
    );
  }

  async componentDidMount() {
    document.addEventListener("onLoadRadioMetadata", (event) => {
      // Apenas os metadados da rádio estarão disponíveis aqui, mas isso já é suficiente
      // para exibir uma tela de "Carregando..." com o logotipo e cores da rádio
      setCssVar("--logo-height", `${event.detail.radio.logo_height}px`);
      setCssVar("--color1", event.detail.radio.color_one);
      setCssVar("--color2", event.detail.radio.color_two);
      setCssVar("--color3", event.detail.radio.color_three);
      setCssVar("--spacing", `${event.detail.radio.spacing}px`);
      setCssVar("--videos-na-tela", event.detail.radio.videos_screen);
      setCssVar("--playlist-height", `${event.detail.radio.playlist_height}px`);
      if (event.detail.radio.text_color) {
        setCssVar("--text-color", event.detail.radio.text_color);
      }
      this.setState({ radio: event.detail.radio });
    });

    this.setState({ radio: await this.service.getRadio(), loading: false });
  }
}

export default App;
